import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const guarantees = ['Descarga instantánea', 'Acceso de por vida', 'Garantía de 7 días'];
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-bone" data-id="element-118" data-mp="4m8mecr76rkx">
      <div className="bg-court absolute inset-0" aria-hidden="true" data-id="element-119" data-mp="4jvup7vn12uo" />

      <div className="relative mx-auto max-w-5xl px-5 pb-16 pt-12 text-center lg:pb-20 lg:pt-16" style={{
      paddingTop: "20px"
    }} data-id="element-120" data-mp="128yz6bncnty4">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="inline-flex items-center gap-2.5 rounded-full border-2 border-ink bg-white px-4 py-2" data-id="element-121" data-mp="x8joxsyd72kd">
          <span className="flex items-center gap-0.5 text-brand" aria-hidden="true" data-id="element-122" data-mp="3d2bkprwf73wl">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" data-id="element-123" data-mp="384s2yi0ik8zw" data-mpi={index} />)}
          </span>
          <span className="text-xs font-extrabold uppercase tracking-[0.12em] text-ink" data-id="element-124" data-mp="3j6obhix6kkpk">
            4.9/5 · +1.500 profes
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: EASE
      }} className="balance mx-auto mt-7 max-w-3xl font-display text-[2.3rem] leading-[0.97] tracking-[-0.015em] text-ink sm:text-[3.2rem] lg:text-[4rem]" data-id="element-125" data-mp="399jlt944m740">
          Resolvé un año entero de clases de Educación Física en solo{' '}
          <span className="relative inline-block whitespace-nowrap text-brand" data-id="element-126" data-mp="2qkwmz8cjmdyv">
            5 minutos
            <span className="absolute inset-x-0 -bottom-1 h-[0.12em] rounded-full bg-volt" aria-hidden="true" data-id="element-127" data-mp="2vjpy4u4cxsvv" />
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: EASE
      }} className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-ink/70 sm:text-lg" data-id="element-128" data-mp="2lkqyu25hf9lj">
          <span className="font-bold text-ink" data-id="element-129" data-mp="najivs7dilh4">
            Basta de quemar domingos enteros planificando.
          </span>{' '}
          Cada hora que perdés buscando juegos en Google no vuelve nunca más:
          descargás, imprimís y entrás al patio.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease: EASE
      }} className="relative mx-auto mt-4 w-full max-w-4xl" data-id="element-130" data-mp="1b15qjidgu3ql">
          <img src="https://cdn.magicpatterns.com/uploads/595ogAx8CGbGrrYj6UFj6F/fe73dd55-c1f7-4a84-ace3-cd1a42b7abc9.webp" alt="El Kit Educación Física Lista: los doce cuadernillos de 1º Primaria a 6º Secundaria junto a la plataforma digital en monitor, tablet y celular" className="block w-full" data-id="element-131" data-mp="110wohnwslo3a" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.22,
        ease: EASE
      }} className="mx-auto mt-2 max-w-xl text-sm font-semibold leading-relaxed text-ink/60" data-id="element-132" data-mp="3htpyjt6msmmz">
          12 volúmenes (1º Primaria a 6º Secundaria) + Kit de Evaluación + 5
          bonos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.26,
        ease: EASE
      }} className="mt-6" data-id="element-133" data-mp="2b1932fkwnatf">
          <CtaButton label="Quiero mi Kit ahora" href="#offer" className="w-full sm:w-auto" data-id="element-134" data-mp="2kyduouxiryhm" />
          

          <ul className="mx-auto mt-6 flex max-w-2xl flex-wrap items-center justify-center gap-x-7 gap-y-3" data-id="element-135" data-mp="2ozz05v7q5ahs">
            {guarantees.map(item => <li key={item} className="flex items-center gap-2 text-sm font-bold text-ink/75" data-id="element-136" data-mp="2tz1xsuldkefq">
                <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-volt" data-id="element-137" data-mp="uo0to10suspl">
                  <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" strokeWidth={3} data-id="element-138" data-mp="zm2lbacak0co" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}